import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
export function decodeBase64(base64) {
  // base64字符串解码
  var buffer = Buffer.from(base64, 'base64');
  return buffer.toString();
}
export function decodeJwtPayload(jwt) {
  var parts = jwt.split('.');
  return JSON.parse(decodeBase64(parts[1]));
}